import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import moment from "moment";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import { CalendarCheckSolidV6 } from "@shared/v2/Icomoon";
import TaskModal from "../../../Tasks/components/TaskModal";

class ViewAllAppointmentsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allAppointments: [],
      selectedTask: null,
      editAppointment: false,
    };
  }

  componentDidMount() {
    const { person } = this.props;
    this.getAllAppointments(person.data.attributes.uuid);
  }

  getAllAppointments = (id) => {
    axios
      .get("/tasks/appointments", {
        params: { id, limit: 100 },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.getAllAppointmentsSuccess(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getAllAppointmentsSuccess = (data) => {
    this.setState({ allAppointments: data.tasks });
  };

  editTask = (task) => this.setState({ selectedTask: task, editAppointment: true });

  closeTaskDetails = () => this.setState({ editAppointment: false });

  render() {
    const { onClose, person, user, taskable, updateTask } = this.props;
    const { allAppointments, editAppointment, selectedTask } = this.state;
    return (
      <>
        <Modal
          id="view-all-appointments-modal"
          show={!editAppointment}
          onHide={onClose}
          dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
          contentClassName="tw-max-w-[800px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
        >
          <Modal.Header title="Appointments" closeButton />

          <Modal.Body className="tw-flex-1 tw-overflow-auto tw-flex tw-flex-col tw-gap-[24px]">
            {allAppointments.map((appt) => (
              <div className="tw-flex tw-gap-[16px]" key={appt.id}>
                <div className="tw-flex-none tw-w-[42px] tw-h-[42px] tw-border-solid tw-border-[2px] tw-rounded-full tw-flex tw-justify-center tw-items-center">
                  <CalendarCheckSolidV6 size="l" />
                </div>
                <div className="tw-flex-1">
                  <p>
                    <strong>Name:</strong> {appt.name}
                  </p>
                  <p>
                    <strong>Due:</strong> {moment(appt.due_on).format("MMMM D, YYYY [at] h:mm A")}
                  </p>
                  <p>
                    <strong>Appointment Type:</strong> {appt.appointment_type}
                  </p>
                  <p>
                    <strong>Outcome:</strong> {appt.outcome}
                  </p>
                  <p>
                    <strong>Location:</strong> {appt.location}
                  </p>
                  <p className="tw-flex tw-flex-col tw-gap-[4px] tw-whitespace-pre-wrap">
                    <strong>Notes:</strong>
                    <span>{appt.note}</span>
                  </p>
                </div>
                <Button size="medium" onClick={() => this.editTask(appt)}>
                  Edit
                </Button>
                {appt.logged_ago && <span>{appt.logged_ago}</span>}
              </div>
            ))}
          </Modal.Body>

          <Modal.Footer className="tw-flex tw-justify-end">
            <Button size="medium" onClick={onClose}>
              Done
            </Button>
          </Modal.Footer>
        </Modal>

        {editAppointment && (
          <TaskModal
            person={person}
            onClose={this.closeTaskDetails}
            user={user}
            taskable={taskable}
            task={selectedTask}
            updateTask={(task) => {
              this.setState({
                allAppointments: allAppointments.map((t) => (t.id === task.id ? task : t)),
              });
              updateTask({ ...task });
            }}
          />
        )}
      </>
    );
  }
}

ViewAllAppointmentsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  person: PropTypes.shape().isRequired,
  user: PropTypes.shape().isRequired,
  taskable: PropTypes.shape().isRequired,
  updateTask: PropTypes.func.isRequired,
};

export default ViewAllAppointmentsModal;
